module.exports = __webpack_public_path__ + "static/media/Food-1.36e0f853.png";